<template>
    <div id="focus-watch">
        <div class="input">
            <div> 
                <!-- <c-input v-model="time" type="select" :options="timings" :displayLabel="false"></c-input> -->
                <select v-model="time" :disabled="running" @change="onTimeSelected">
                    <option v-for="(t, i) in getDurations" :key="i" :value="t.value">{{t.label}}</option>    
                </select>   
            </div>        
            <div :class="{hint: hint, warning: warning, blink: selectedTime==0}">{{this.formatTime}}</div>
        </div>
        <div class="icon button" :class="{watch: !running, reset: running, disabled: !clickable}" @click="running = !running"></div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import CInput from './CInput';

export default {
    name: "FocusWatch",
    data: ()=>{
        return {
            running: false,
            time: 60,
            selectedTime: null,
            timer: null,
            warning: false,
            hint: false,
            clickable: true,
            simpleSound: new Audio(require('../../assets/sound/beep-short.mp3')),
            longSound:new Audio(require('../../assets/sound/beep-long.mp3')),
            beepAt: [1,2,3,4,5,10,15],
            durations: [{
                value: 30,
                label: '0:30',
                heatTypes: [0,1,2,3,4,5,6,7]
            },{
                value: 60,
                label: '1:00',
                heatTypes: [0,1,2,3,4,5,6,7]
            },{
                value: 90,
                label: '1:30',
                heatTypes: [0,1,2,3,4,5,6,7]
            },{
                value: 120,
                label: '2:00',
                heatTypes: [0,1,2,3,4,5,6,7]
            },{
                value: 180,
                label: '3:00',
                heatTypes: [0,1,2,3,4,5,6,7]
            },{
                value: 240,
                label: '4:00',
                heatTypes: [0,1,2,3,4,5,6,7]
            },{
                value: 300,
                label: '5:00',
                heatTypes: [0,1,2,3,4,5,6,7]
            },{
                value: 360,
                label: '6:00',
                heatTypes: [0,1,2,3,4,5,6,7]
            },],

        }
    },
    methods:{
        onTimeSelected() {
            this.selectedTime = this.time;
        },
    },
    watch: {
        running() {            
            if(this.clickable){
                if(this.running) {
                    this.clickable = false;
                    this.selectedTime--;
                }
                else{
                    this.selectedTime = this.time;
                }
                clearTimeout(this.timer);
            }
        },
        selectedTime(value) {
            if (value > 0 && this.running) {
                this.timer = setTimeout(() => {
                    this.selectedTime--;
                }, 1000);
            }
            this.hint = value <= 15;
            this.warning = value <= 5;
        },
        clickable(val){
            if(!val) {
                setTimeout(() => {
                    this.clickable = true;
                }, 1000);
            }
        },
        NEntryId(){
            this.running = false;
        }
    },
    computed: {   
        ...mapGetters(['NEntryId', 'SelectedHeat']),     
        formatTime(){
            const m = Number.parseInt(this.selectedTime / 60);
            const s = this.selectedTime % 60;
            if(this.beepAt.includes(this.selectedTime))this.simpleSound.play();
            if(this.selectedTime == 0)this.longSound.play();
            return `${m}:${s < 10 ? '0'+s : s}`;
        },
        getDurations(){
            return this.durations.filter(x => x.heatTypes.includes(this.SelectedHeat.type));
        }
    },
    components:{
        CInput,
    },
    mounted(){
        this.selectedTime = this.time;
    }
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    #focus-watch {
        @extend %f-row;

        background-color: $form-bg-color;
        padding:10px;
        padding-top: 0px;
    }

    .input {
        @extend %f-row;
        width:75%;
        font-size:35px;

        select {
            width: 100%;
            height: $height_high;
            outline: none;
            background-color: $form-bg-color;
            color: $font-light-color;
            border: solid 2px $font-light-color;
            font-size:35px;
        }

        > div:first-of-type {
            width:110px;
            max-width:110px;
            padding-left: 0px;
            margin: 0px;
        }
        
        > div {
            @extend %f-grow;

            display: flex;
            height: $height_mid;
            align-items: center;
            box-sizing: border-box;
            justify-content: center;
            min-width: 80px;
            margin: 0 10px;
            font-weight:bold;
        }

        .hint {
            color:$prim_warning_color;
        }

        .warning {
            color:$prim_aleart_light_color;
        }
    }

    .button {
        width:25%;
        height: $height_high;
        border: solid 1px $sec_color_dark;
        background-color: $button-bg-dark;
        text-align: center;
        box-sizing: border-box;
    }    

    .icon {
        font: normal normal normal 24px/1 "Material Design Icons";
        line-height: $height_high;
        cursor: pointer;
    }

    .watch::after {
        content: "\F006B";
    }

    .reset::after {
        content: "\F0450";
    }

    .disabled {
        opacity: 0.5;
    }          

    .blink {
        animation: blink-bg 1s infinite alternate;
    }        

    @keyframes blink-bg {
        0% {
            background-color: $prim_aleart_color;
        }

        100% {
            background-color: $prim_aleart_color_blink;
        }  
    }

</style>